import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=a01a615e&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a01a615e')) {
      api.createRecord('a01a615e', component.options)
    } else {
      api.reload('a01a615e', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=a01a615e&", function () {
      api.rerender('a01a615e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2j5GmkMgYfn87/JS/pricehelp.vue"
export default component.exports